/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';

export const SWITCH_TOGGLE_EVENTS = {
  handleSwitch: 'switchToggle:handleSwitch',
  reset: 'switchToggle:reset',
  handleDisabled: 'switchToggle:handleDisabled',
}

export default class SwitchComponent extends Component {
  get SELECTORS() {
    return {
      switchToggleList: '[data-switch-toggle]',
    }
  }
  constructor(htmlEl) {
      super(htmlEl);
      this.$component = htmlEl;

      this.switchToggleList = document.querySelectorAll(this.SELECTORS.switchToggleList)
  }

  bindEvents() {
    let that = this;
    if (this.switchToggleList) {
      this.switchToggleList.forEach(switchToggle => {
        switchToggle.addEventListener('change', function(event) {
          that.$emit(SWITCH_TOGGLE_EVENTS.handleSwitch, { id: event.target.id, value: event.target.checked });
        })
      })

      let switchToggleList = this.switchToggleList
      this.$on(SWITCH_TOGGLE_EVENTS.reset, ({payload}) => {
        let switchToggle = null;
        switchToggleList.forEach(s => {
          if (`switch-input-${payload.id}` === s.id) switchToggle = s
        })
        if (switchToggle) switchToggle.checked = false
      })

      this.$on(SWITCH_TOGGLE_EVENTS.handleDisabled, ({payload}) => {

        let switchToggle = null;
        switchToggleList.forEach(s => {
          if (`switch-input-${payload.id}` === s.id) switchToggle = s
        })
  
        if (switchToggle) {
          if (payload.disabled === 'true') switchToggle.disabled = payload.disabled
          else switchToggle.removeAttribute('disabled');
        }

      })
    }
  }

  render() {
      super.render();
      this.bindEvents()
  }
}